import { useEffect } from 'react';

const getCapitalizedWord = (word: string) => word?.charAt(0)?.toUpperCase() + word?.slice(1);

export const useDocumentTitle = (pathname: string) => {
  useEffect(() => {
    let pathName = pathname;

    // in the case of redirect, sometimes the pathname contains a trailing slash. remove it.
    if (pathname?.endsWith('/')) {
      pathName = pathname?.substring(0, pathname?.length - 1);
    }

    /**
     * if, for example, the pathname is /portal/marketing-stuff/campaigns,
     * then the pathSections would be 'portal', 'marketing-stuff', and 'campaigns'.
     * each word of each pathSection needs capitalization.
     * so if the pathSection contains a `-`, then split into an array on the `-` and loop again to capitalize each word.
     * in this example, the pathSectionWords would be 'marketing' and 'stuff'.
     * if the pathSection does not contain a `-`, do not loop again. just return the capitalized word.
     */
    const documentTitle = pathName
      // remove the leading slash
      ?.slice(1)
      ?.split('/')
      ?.map((pathSection) => {
        // only enter nested loop if pathSection has multiple words that need to be capitalized
        if (pathSection?.split('-')?.length > 1) {
          return pathSection
            ?.split('-')
            ?.map((pathSectionWord) => getCapitalizedWord(pathSectionWord))
            ?.join(' ');
        } else return getCapitalizedWord(pathSection);
      })
      // only show the first two items in the array
      ?.slice(0, 2)
      ?.join(' - ');

    document.title = documentTitle;
  }, [pathname]);
};
